import { ArrowRight } from "lucide-react";
import { SERVICES } from "./data";
import { Chapter, Rise } from "./motion";
import { scrollTo } from "./scroll";

const Services = () => (
  <section
    id="services"
    data-testid="services-section"
    className="border-b-2 border-ink bg-cream"
  >
    <div className="mx-auto max-w-[1500px] px-4 py-20 sm:px-6 lg:py-28">
      <Rise>
        <Chapter num="02" label="Services" />
      </Rise>
      <Rise delay={0.1}>
        <h2 className="mt-6 font-display text-[14vw] uppercase leading-[0.85] sm:text-8xl lg:text-[10rem]">
          The <span className="text-stroke-ink">Cuts</span>
        </h2>
      </Rise>

      <div className="mt-14 grid grid-cols-1 gap-7 md:grid-cols-2 lg:grid-cols-3">
        {SERVICES.map((s, i) => (
          <Rise
            key={s.name}
            delay={0.06 * i}
            className={i % 2 === 0 ? "lg:-rotate-1" : "lg:rotate-1"}
          >
            <article
              data-testid={`service-card-${i}`}
              className="group relative h-full border-2 border-ink bg-paper p-7 shadow-hard transition-transform duration-150 hover:-translate-y-1"
            >
              <div className="flex items-start justify-between">
                <span className="font-mono2 text-xs font-bold text-polered">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span className="font-mono2 text-right text-2xl font-bold">{s.price}</span>
              </div>
              <h3 className="mt-8 font-display text-4xl uppercase leading-none">
                {s.name}
              </h3>
              <p className="mt-3 border-t border-dashed border-ink/30 pt-3 text-sm font-medium text-ink/70">
                {s.desc}
              </p>
              {s.note && (
                <span className="mt-3 inline-block -rotate-1 border border-ink bg-polered px-2 py-0.5 font-mono2 text-[10px] font-bold uppercase tracking-widest text-paper">
                  {s.note}
                </span>
              )}
              <span className="absolute right-3 top-1/2 h-10 w-1 bg-ink/10 transition-colors group-hover:bg-rust" />
            </article>
          </Rise>
        ))}
      </div>

      <Rise delay={0.15}>
        <p className="mt-10 max-w-lg font-mono2 text-xs uppercase tracking-[0.15em] text-ink/60">
          * Price &amp; time may vary depending on the length and thickness of
          your hair and what you&rsquo;re after.
        </p>
      </Rise>

      <Rise delay={0.15}>
        <figure
          data-testid="pricelist-artwork"
          className="relative mx-auto mt-16 max-w-xl border-2 border-ink bg-paper p-3 shadow-hard"
        >
          <div className="tape -top-3 left-1/2 z-10 -translate-x-1/2 rotate-2" />
          <img
            src="/photos/pricelist.jpg"
            alt="The original framed Oliver's Barber Shop price list hanging in the shop"
            loading="lazy"
            className="w-full"
          />
          <figcaption className="pt-3 text-center font-hand text-xl text-ink/70">
            The real deal, hanging in the shop — cash is king.
          </figcaption>
        </figure>
      </Rise>

      <Rise delay={0.2}>
        <a
          href="#walkin"
          onClick={(e) => {
            e.preventDefault();
            scrollTo("#walkin");
          }}
          data-testid="services-cta"
          className="mt-12 inline-flex items-center gap-3 font-display text-2xl uppercase text-rust underline decoration-4 underline-offset-8 transition-colors hover:text-ink"
        >
          Walk in or call <ArrowRight size={24} />
        </a>
      </Rise>
    </div>
  </section>
);

export default Services;
